<template>
  <div class="empty-status">
    <img
      :src="getImage('noneMessage')"
      alt="noneMessage"
      :style="{ width, height }"
    />
    <p>{{ message }}</p>
  </div>
</template>

<script lang="ts" setup>
  import usePub from '@/utils/pub-use';

  const getImage = usePub;
  const props = defineProps({
    message: {
      type: String,
      default: '暂无数据',
    },
    height: {
      type: String,
      default: '80px',
    },
    width: {
      type: String,
      default: '80px',
    },
  });
</script>

<style lang="less" scoped>
  .empty-status {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    & > p {
      position: absolute;
      text-align: center;
      width: 100%;
      top: 70%;
      color: var(--color-text-3);
    }
  }
</style>
